var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "documents-list" },
    [
      _c("doctype-sidesheet", {
        ref: "modal",
        on: { update: _vm.reload, "remove-group": _vm.onGroupRemove },
      }),
      _c("u-confirm", { ref: "confirm", attrs: { id: "delete-doctype" } }),
      _vm.loading
        ? _c("c-loader", {
            attrs: { label: "", active: _vm.loading, height: "500" },
          })
        : _vm._e(),
      !_vm.loading
        ? _c("div", [
            _vm.hasVisibleItems
              ? _c(
                  "div",
                  [
                    _c(
                      "draggable",
                      {
                        staticClass: "item-container",
                        attrs: {
                          tag: "div",
                          "ghost-class": "sortable__ghost",
                          group: "list",
                          move: _vm.onMove,
                          "force-fallback": true,
                        },
                        on: { change: _vm.resortDocuments },
                        model: {
                          value: _vm.documents,
                          callback: function ($$v) {
                            _vm.documents = $$v
                          },
                          expression: "documents",
                        },
                      },
                      _vm._l(_vm.documents, function (document) {
                        return _c(
                          "div",
                          {
                            key: document.type + document.id,
                            staticClass: "item-group",
                            attrs: { "data-type": document.type },
                          },
                          [
                            document.type === "group" &&
                            _vm.isDocumentVisible(document)
                              ? _c(
                                  "div",
                                  [
                                    _c("documents-group", {
                                      attrs: {
                                        group: document,
                                        query: _vm.normalizedQuery,
                                        "selected-tab": _vm.selectedTab,
                                      },
                                      on: {
                                        "edit-group": _vm.onGroupEdit,
                                        "remove-group": _vm.onGroupRemove,
                                        "remove-document": _vm.onDocumentRemove,
                                        resort: _vm.resortDocuments,
                                        "add-document":
                                          _vm.onDocumentAddToGroup,
                                        move: _vm.onDocumentMove,
                                        archiveGroup: _vm.onGroupArchive,
                                        archiveDocument: _vm.onDocumentArchive,
                                      },
                                    }),
                                  ],
                                  1
                                )
                              : document.type === "without-group" &&
                                _vm.isDocumentVisible(document)
                              ? _c(
                                  "div",
                                  [
                                    _c("documents-group", {
                                      attrs: {
                                        fake: true,
                                        group: document,
                                        query: _vm.normalizedQuery,
                                        "selected-tab": _vm.selectedTab,
                                      },
                                      on: {
                                        "edit-group": _vm.onGroupEdit,
                                        "remove-group": _vm.onGroupRemove,
                                        "remove-document": _vm.onDocumentRemove,
                                        resort: _vm.resortDocuments,
                                        "add-document":
                                          _vm.onDocumentAddToGroup,
                                        move: _vm.onDocumentMove,
                                        archiveDocument: _vm.onDocumentArchive,
                                      },
                                    }),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ]
                        )
                      }),
                      0
                    ),
                  ],
                  1
                )
              : _c("div", { staticClass: "documents-list__empty" }, [
                  _vm._v(
                    "Ничего не найдено. Попробуйте изменить параметры поиска."
                  ),
                ]),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }